import React, {useState} from "react";
import "./TokenClaimTable.css";
const TokenClaimTable = () => {
  const data = [
    {
      token: "DRIP",
      allocation: "20,000.00",
      availableClaim: "3,000.00",
      Claimed: "9,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "250,000.00",
      availableClaim: "15,000.00",
      Claimed: " 145,000.00",
    },
    {
      token: "RAKE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },

    {
      token: "BR34P",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "DRIP",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
    {
      token: "ACQUIRE",
      allocation: "4,348.667.24",
      availableClaim: "1,844,526.77",
      Claimed: "145,000.00",
    },
  ];
  return (
    <div className="mt-[144px] ">
      <h2 className="text-main-green text-center text-res-lg font-bold mb-[32px]">
        Token Claim
      </h2>
      <div>
        <div className="lg:w-full mt-[29px]   table-top-wrap flex justify-center text-center">
          <div className=" overflow-x-scroll lg:overflow-hidden max-w-[1016px] w-full">
            <table
              cellSpacing="0"
              cellPadding="0"
              className="min-w-[900px] w-full px-[200px]"
            >
              <thead className="h-[50px]  ">
                <tr>
                  <th className="rounded-tl-[10px]">TOKEN</th>
                  <th>ALLOCATION</th>
                  <th>TIME TO NEXT CLAIM</th>
                  <th>AVAILABLE TO CLAIM</th>
                  <th>CLAIMED SO FAR</th>
                  <th className="rounded-tr-[10px]">ACTION</th>
                </tr>
              </thead>
              <tbody className="text-res-xs font-semibold">
                <tr className="first-row">
                  <td>DRIP </td>
                  <td>20,000.00</td>
                  <td>05:16:42:27</td>
                  <td>3,000.00</td>
                  <td>9,000.00</td>
                  <td>
                    <button className="bg-[#DCDCDC] rounded-[20px] border border-white text-[12px] font-bold leading-[14px] w-[122px] h-[30px] text-[#202020]">
                      Claim
                    </button>
                  </td>
                </tr>
                {data.splice(1).map((single, i) => (
                  <tr key={i}>
                    <td>{single.token}</td>
                    <td>{single.allocation}</td>
                    <td>05:16:42:27</td>
                    <td>{single.Claimed}</td>
                    <td>9,000.00</td>
                    <td>
                      <button className="bg-[#DCDCDC] rounded-[20px] border border-white text-[12px] font-bold leading-[14px] w-[122px] h-[30px] text-[#202020]">
                        Claim
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenClaimTable;
